<template>
    <div id="vancouver-generator" class="vancouver-citation-generator">
        <Breadcrumb v-bind:title="this.$t('vancouver.page-title')"/>

        <div class="container">
            <div class="citation__wrap">

                <div class="citation__side">
                    <div class="sidebar-container">
                        <LeftSidebar/> <!-- left sidebar -->

                        <!-- CiteResults -->
                        <CiteResults/>
                    </div>
                </div>

                <div class="citation__content">
                    <!-- Content / SEO -->
                    <PageContent v-bind:title='this.$t("vancouver.page-title")' v-bind:description='this.$t("vancouver.page-description")' />

                    <!-- 스타일 / 타입 선택 -->
                    <div class="ct-select-wrap">
                        <h6 class="title">{{$t('site_desc')}}</h6>
                        <div class="ct-select-box">
                            <SelectStyle v-bind:current-style="this.currentStyle" v-bind:select-style="this.selectStyle" v-on:changeStyle="changeStyle"/>
                            <SelectSource v-bind:current-style="this.currentStyle" v-bind:select-style="this.selectStyle" v-bind:select-source="this.selectSource" v-on:changeSource="changeSource"/>
                        </div>
                    </div>

                    <!-- Example -->
                    <GeneratorExample v-bind:select-style="this.selectStyle" v-bind:select-source="this.selectSource"/>

                    <!-- contributor -->
                    <Contributor v-model="contributor" v-bind:cite-style="this.selectStyle"></Contributor>

                    <!-- 선택에 따라 동적으로 컴포넌트 로드 -->
                    <keep-alive>
                        <component ref="form_info" v-if="this.selectStyle" v-bind:is="selectedComponent" v-bind:citation-style="this.selectStyle" v-model="component_form_data" class="mt-3">
                        </component>
                    </keep-alive>

                    <!-- 생성 버튼 -->
                    <GenerateButton v-bind:citation-style="this.selectStyle" v-bind:citation-source="this.selectSource" v-bind:contributor-data="this.contributor" v-bind:form-data="this.formData" v-on:getFormData="getFormData"/>

                    <!-- help Message -->
                    <HelpMessage v-bind:msg-text="helpMessageText" v-bind:citation-style="this.selectStyle" v-bind:citation-source="this.selectSource" v-if="isShowHelpMessage" @close-modal="isShowHelpMessage=false"/>

                    <!-- Quick Guide -->
                    <hr>
                    <QuickGuide v-bind:citation-style="this.currentStyle"/>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "./Breadcrumb"
import SidebarLeft from "./SidebarLeft"
import PageContent from "./PageContent"
import SelectStyle from "./SelectStyle"
import SelectSource from "./SelectSource"
import GeneratorExample from "@/components/generator-example/GeneratorExample"
import Contributor from "@/components/FormContributor"
import FormWebpage from "@/components/FormWebpage"
import FormJournalArticle from "@/components/FormJournalArticle"
import FormBook from "@/components/Formbook"
import HelpMessage from "@/components/HelpMessage"
import QuickGuide from "@/components/generator/QuickGuide"
import GenerateButton from "./GenerateButton"
import CiteResults from "./CiteResults"

export default {
    name: "VancouverGenerator",
    components: {
        "Breadcrumb" : Breadcrumb,
        "LeftSidebar" : SidebarLeft,
        "PageContent" : PageContent,
        "SelectStyle" : SelectStyle,
        "SelectSource" : SelectSource,
        "GeneratorExample" : GeneratorExample,
        "Contributor" : Contributor,
        "webpage" : FormWebpage,
        "article-journal" : FormJournalArticle,
        "book" : FormBook,
        "GenerateButton" : GenerateButton,
        "CiteResults" : CiteResults,
        "HelpMessage" : HelpMessage,
        "QuickGuide" : QuickGuide,
    },
    data: function () {
        return {
            currentStyle: "vancouver",
            selectStyle: "vancouver",
            selectSource: "webpage",
            contributor: [{contributor : '', given : '', middle : '', family : ''}],
            selectedComponent : "",
            component_form_data: {},
            isShowHelpMessage: false,
            helpMessageText: "",
            formData: {
                'container-title' : '',
                title: '',
                URL: '',
                issued : {
                    'date-parts' : [['', '', '']],
                },
                accessed : {
                    'date-parts' : [['', '', '']],
                },
            },
        }
    },
    metaInfo() {
        // og tag는 SSR 이 필요함. _ Wordvice 시스템에서 처리 / NewSystemController
        return {
            title: this.$t("vancouver.meta-title"),
            titleTemplate: '%s | ' + this.$t('Brand Name'),
            meta: [
                { vmid: "description", name: "description", content: this.$t("vancouver.meta-description") }
            ],
            link: [
                {rel: 'canonical', href: `${window.location.origin}/vancouver-citation-generator`}
            ]
        }
    },
    methods : {
        changeStyle(style) {
            this.selectStyle = style
        },
        changeSource(source) {
            this.selectSource = source
            this.selectedComponent = source
        },
        getFormData() {
            this.formData = this.$refs.form_info.return_data
        },
        showHelpMessage (idx) {
            this.isShowHelpMessage = true;
            this.helpMessageText = idx; //vue 파일 이름
            document.body.classList.add("modal-open");
        }
    },
    mounted() {
        this.selectedComponent = this.selectSource
    }
}
</script>

<style lang="scss">
@import "~assets/_global";
@import "~assets/_reset";
</style>

<style scoped lang="scss">
#vancouver-generator /deep/ {
    @import "~assets/_generator";
}
</style>


// WEBPACK FOOTER //
// src/components/generator/genVancouver.vue